export const LOCAL_STORAGE_ACCESS_TOKEN = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken'

/**
 * While impersonating, the operator's own tokens are set aside under these keys and the impersonated
 * token takes over the active ones above, so the request interceptor keeps reading a single source of
 * truth. The presence of IMPERSONATION_ORIGINAL_ACCESS_TOKEN is what defines "currently impersonating".
 */
export const IMPERSONATION_ORIGINAL_ACCESS_TOKEN = 'impersonationOriginalAccessToken'
export const IMPERSONATION_ORIGINAL_REFRESH_TOKEN = 'impersonationOriginalRefreshToken'
export const IMPERSONATION_STARTED_AT = 'impersonationStartedAt'

/**
 * Every restore ends in a full reload, which wipes in-memory toast state — so the "your impersonated
 * session ended" notice is handed to the next page load through here instead of being shown before it.
 */
export const IMPERSONATION_ENDED_NOTICE = 'impersonationEndedNotice'

/** The backend issues impersonated tokens with a fixed 1-hour lifetime and no refresh token. */
export const IMPERSONATION_DURATION_MS = 3_600_000
export const IMPERSONATION_WARNING_THRESHOLD_MS = 5 * 60_000
